// extracted by mini-css-extract-plugin
module.exports = {"page":"RecoveryPassPage_page__7i91j page_page__31uF2"};